import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import template from './uploadStatusMessage.jsx';
import uploadStatuses from './uploadStatuses';
var getSplittedFileName = function getSplittedFileName(fileName) {
  return _.split(fileName, '.');
};
var getFileNamePrefix = function getFileNamePrefix(fileName) {
  var splittedFileName = getSplittedFileName(fileName);
  return splittedFileName[0] + (splittedFileName[1] ? '.' : '');
};
var UploadStatusMessage = /*#__PURE__*/function (_React$Component) {
  function UploadStatusMessage(props) {
    var _this;
    _classCallCheck(this, UploadStatusMessage);
    _this = _callSuper(this, UploadStatusMessage, [props]);
    _this.getMessage = function () {
      if (_this.props.status === uploadStatuses.UPLOAD_SUCCESS) {
        return getFileNamePrefix(_this.props.value);
      }
      if (_this.props.status === uploadStatuses.UPLOAD_FAILED) {
        return _this.props.errorMessage;
      }
      if (_this.props.status === uploadStatuses.IN_PROCESS) {
        return _this.props.processMessage;
      }
    };
    _this.getFileExtension = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS ? getSplittedFileName(_this.props.value)[1] || '' : '';
    };
    _this.isStatusNone = function () {
      return _this.props.status === uploadStatuses.NONE;
    };
    _this.isStatusUploadSuccess = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS;
    };
    _this.isStatusUploadFailed = function () {
      return _this.props.status === uploadStatuses.UPLOAD_FAILED;
    };
    _this.shouldTranslateMainMessage = function () {
      return _this.props.status === uploadStatuses.UPLOAD_SUCCESS ? false : _this.props.shouldTranslate;
    };
    _this.getEllipsisProps = function () {
      return {
        customTrigger: _this,
        displayCustomTrigger: true,
        customTooltipMessage: _this.getMessage() + _this.getFileExtension()
      };
    };
    return _this;
  }
  _inherits(UploadStatusMessage, _React$Component);
  return _createClass(UploadStatusMessage, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
UploadStatusMessage.displayName = displayNames.UPLOAD_BUTTON_STATUS_MESSAGE;
UploadStatusMessage.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The uploading file name */
  value: PropTypes.string,
  /** The status of the upload */
  status: PropTypes.oneOf(uploadStatuses.UPLOAD_STATUS),
  /** Text content in case of an error in upload */
  errorMessage: PropTypes.string,
  /** Text content during upload process */
  processMessage: PropTypes.string
};
export default compose(UploadStatusMessage);